var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper"},[_c('LogoMark',{staticClass:"loading-panel__logo",attrs:{"width":"40px","height":"54px"}}),_c('p',[_vm._v("Loading…")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }